import { styled } from '../../../theme/stitches.config';

export const SMPDivider = styled('hr', {
  display: 'block',
  width: '100%',
  variants: {
    variant: {
      base: {
        borderTop: '1px solid $dividerBorderColor',
        borderBottom: 'transparent',
        margin: '0px',
      },
    },
  },
  defaultVariants: {
    variant: 'base',
  },
});
